import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { Form } from "@carrotfertility/carotene-core-x"
import {
  useCheckRoutingInfoQueryCache,
  useUpdateRoutingInfo
} from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import {
  ButtonFooterLayout,
  ContinueButton,
  RoutingFlowTitle,
  StepLayout,
  useConvertTranslatedLabel
} from "#/components/carrot-plans/shared"
import { FormRadioButtonGroup } from "#/services/common-forms"
import { PreservationInterest } from "#/components/carrot-plans/types/preservationInterest"

const OPTIONS = [
  { label: defineMessage({ defaultMessage: "Preserving sperm" }), value: PreservationInterest.PRESERVE_SPERM },
  { label: defineMessage({ defaultMessage: "Preserving eggs" }), value: PreservationInterest.PRESERVE_EGGS },
  { label: defineMessage({ defaultMessage: "Preserving embryos" }), value: PreservationInterest.PRESERVE_EMBRYOS },
  {
    label: defineMessage({ defaultMessage: "Preserving both eggs/embryos and sperm" }),
    value: PreservationInterest.PRESERVE_EGGS_EMBRYOS_OR_SPERM
  }
]

export default function PreservationStep(): JSX.Element {
  const { mutateAsync } = useUpdateRoutingInfo()
  const routingData = useCheckRoutingInfoQueryCache()
  const defaultValue = routingData?.preservationInterest
  const { send } = useStateMachine(defaultValue)
  const intl = useIntl()
  const radioOptions = useConvertTranslatedLabel(OPTIONS)

  async function onClickContinue(formValues: { preservationInterest: string }): Promise<void> {
    await mutateAsync(formValues, { onSuccess: () => send(formValues.preservationInterest) })
  }

  const header = intl.formatMessage({
    defaultMessage: "What kind of preservation are you interested in?"
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={<span id="preservationInterest-label">{header}</span>}
        formElements={
          <Form defaultValues={{ preservationInterest: defaultValue }} onSubmit={onClickContinue}>
            <FormRadioButtonGroup
              name="preservationInterest"
              aria-labelledby="preservationInterest-label"
              options={radioOptions}
              controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
            />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
            />
          </Form>
        }
      />
    </>
  )
}
